
import server from "@/views/agent_im/server";
import { startPolling, stopPolling } from "@/views/agent_im/socket";

export default {
name: "im-menu",
    data() {
    return {
        showStatus: false
    };
},
mounted() {
    this.init()
    document.body.addEventListener("click", this.hideSwitch);
},
computed: {
    agentInfo() {
        return this.$store.state.im.agentInfo;
    },
    unreadcount() {
        let count = 0;
        this.$store.state.im.realTimeSessionList.forEach((item, index) => {
            count += item.msg_unread_count;
        });
        return count;
    }
},
methods: {
    async init(){
        await this.$store.dispatch("im/initAgentInfo");
        await await this.$store.dispatch("im/initRealTimeSessoinList");
        startPolling(data => {
            data.fromSocket = true;
            this.$store.dispatch("im/setInfoCenter", data);
        });
    },
    hideSwitch() {
        this.showStatus = false;
    },
    async setStatus(status) {
        let flag = await server.updateAgentStatus(status);
        if(flag){
            this.$store.dispatch('im/setInfoCenter',{eventType:'AgentImEvent_Logout',fromSocket:false,content:{status}})
        }
    }
},
beforeDestroy() {
    document.body.removeEventListener("click", this.hideSwitch);
}
};
